import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { Redirect, Route, Switch } from "wouter";
import { CompanyGroupView } from "./company-group.view";
import { CreateView } from "./create/create.view";
import { UpdateView } from "./update/update.view";

export function CompanyGroupRoutes() {
  const ability = useAbility();
  const companyGroupUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const canManage = ability.can(Action.Manage, "CompanyGroup");

  return (
    <Switch>
      <Route path={"/"} component={CompanyGroupView} />
      <Route path={"/create"} component={canManage ? CreateView : ReadOnlyRedirect} />
      <Route path={companyGroupUuidRegex} component={canManage ? UpdateView : ReadOnlyRedirect} />
      <Route component={NotFoundView} />
    </Switch>
  );
}

function ReadOnlyRedirect() {
  return <Redirect to="/" replace />;
}
